import parseDialogue from "../../util/parseDialogue";

export const SuperphreakP6 = parseDialogue(`
superphreak:p6:100-700

#100 Hey. I guess you found out ~~~~~ ~~ Get the access codes for Disarray's node. Good work. I'm looking into how to stall the nightfall software. You go get the ~~~~~~~~ codes and then de-activate the program. But first ~~~ ~~ ~~~~ ~~~ what I know about this jerk.
>200 Tell me.

#200 I'm sure Disarray ~~~ boobytrapped the node that has his access codes. I don't know ~~~~~ ~~~~~ ~~~~~~ when you access that node.
>300 Okay.

#300 If you've got any unfinished missions, complete them to ~~~ ~~~~ extra cash. ~~~~~~ ~~~~~ back to Minerva's and stock up on warez.
>400 Got it.

#400 Disarray's tactics - I know that ~~~~~~~~~ ~ coward and will use ranged programs to keeep you ~~ ~ distance. Be prepared to see lots of radar and sonar along with ~~~~~~~ ~~~~~ ~~~ fought. I also know he deletes memory cells as a defense. So be sure ~~~ 
>500 Thanks.

#500 No problem. Did all of that make sense? ~ ~~~~ ~~~ pretty soon there will be no turning back.
>200 Go over that again.
>600 I'm ready.

#600 Alright, I'll be off-line for a while. Good luck ~~~~~~~ ~~~ codes, and be sure ~~ show Disarray what it means to mess with S.M.A.R.T.
>700 I'll do my best.
`);
